module.exports = __webpack_public_path__ + "static/media/16gasto.0ecff34.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/16gasto.mp4
// module id = 722
// module chunks = 1